import React, { FunctionComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import Styles from './NextArrow.module.scss';

interface NextArrowProps {
  style?: any;
  onClick?: (e: React.FormEvent<HTMLDivElement>) => void;
}
const NextArrow: FunctionComponent<NextArrowProps> = (props: NextArrowProps) => {
  const { style, onClick } = props;
  const right: any = faAngleRight;
  return (
    <div
      className={`next-arrow ${Styles.arrowButton}`}
      style={style}
      onClick={onClick}
      onKeyPress={onClick}
      role="button"
      tabIndex={0}
    >
      <FontAwesomeIcon icon={right} />
    </div>
  );
};

export default NextArrow;
